import _ from 'lodash';
import moment from 'moment';

export default function (instance) {
  const originalGetClosestWorkTime = instance.getClosestWorkTime;

  instance.isWorkDay = function (date, calendar) {
    if (_.isString(date)) {
      date = moment(date, 'YYYY-MM-DD HH:mm:ss').toDate();
    } else {
      date = new Date(date);
    }

    let isWorkDay = true;

    if (!calendar && !instance.config.worktimes) {
      return isWorkDay;
    }

    let workDates = calendar ? calendar.getConfig().dates : instance.config.worktimes.global.dates;
    const dayDate = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());

    if (instance.globalCache.isWorkDays[dayDate] && !calendar) {
      return instance.globalCache.isWorkDays[dayDate];
    }

    if (calendar) {
      workDates = calendar.getConfig().dates;
    }

    const day = date.getDay();

    const isCustomDay = _.find(workDates, (value, key) => {
      if (key.length < 2 || dayDate !== +key) {
        return false;
      }

      return true;
    });

    if (_.isUndefined(isCustomDay)) {
      isWorkDay = !!workDates[day];
    } else {
      isWorkDay = !!isCustomDay;
    }

    if (!calendar) {
      instance.globalCache.isWorkDays[dayDate] = isWorkDay;
    }

    return isWorkDay;
  };

  instance.getClosestWorkTime = function () {
    const params = arguments[0];

    if (params.dir === 'past') {
      params.date = new Date(params.date.valueOf() - 1);
    }

    return originalGetClosestWorkTime(params);
  };

  instance.getDefaultWorkHoursPerDay = function (dayHours) {
    const hoursIntervals = dayHours || instance.config.durationData.showTime;
    let workHoursInDay = 0;
    let tempHours = [];

    if (typeof hoursIntervals[0] === 'string') {
      tempHours = hoursIntervals.map(i => i.split('-')).flat(2).map(i => {
        const hours = i.split(':');
        let res = Number(hours[0]);

        if (Number(hours[1])) {
          res += 0.5;
        }

        return res;
      });
    } else {
      tempHours = hoursIntervals;
    }

    for (let i = 0; i < tempHours.length; i += 2) {
      workHoursInDay += tempHours[i + 1] - tempHours[i];
    }

    return workHoursInDay;
  };
}
